__turbopack_context__.v({
  "container": "DevPanel-module__AFOvia__container",
});
